import RichText from '@/components/elements/RichText';
import Image from 'next/image';

const IconCard = ({ title, content, icon }: { title?: string; content?: string; icon?: { url?: string; alternativeText?: string } }) => {
    return (
        <div>
            {icon?.url ? <Image width={44} height={44} src={icon.url} alt={icon.alternativeText || ''} /> : null}
            {title ? <h6 className="normal-case mt-2">{title}</h6> : null}
            {content ? <RichText content={content} className="mt-1" /> : null}
        </div>
    );
};

export default IconCard;
